import React from 'react'
import {
  Definition,
  DefinitionList,
  Section,
  SectionHeader,
} from '@apexinternal/ui-components'
import { BoxProps } from '@chakra-ui/layout'
import { isEmpty } from 'lodash'
import { EPreferences } from 'types'

interface EPreferencesTableProps extends BoxProps {
  ePreferences?: EPreferences
}

const EPreferencesTable = ({
  ePreferences,
  ...rest
}: EPreferencesTableProps) => {
  if (isEmpty(ePreferences) || !ePreferences) {
    return null
  }

  const {
    eStatementIndicator,
    eConfirmIndicator,
    eProspectusIndicator,
    eProxyIndicator,
    eTaxStatementIndicator,
  } = ePreferences

  const displayValue = (preference: string) => {
    switch (preference) {
      case 'PRINT_AND_ELECTRONIC':
        return 'Print and electronic'
      case 'ELECTRONIC_ONLY':
        return 'Electronic only'
      case 'FAILED_EMAIL_DELIVERY':
        return 'Failed email delivery'
      case 'NOT_VIEWED_WITHIN_TIMEFRAME':
        return 'Not viewed within the selected timeframe'
      case 'NOT_USED':
        return 'Not used'
      default:
        return ''
    }
  }

  return (
    <Section {...rest}>
      <SectionHeader>e-Preferences</SectionHeader>
      <DefinitionList>
        {eStatementIndicator && (
          <Definition
            term="Statements"
            definition={displayValue(eStatementIndicator)}
          />
        )}
        {eConfirmIndicator && (
          <Definition
            term="Confirms"
            definition={displayValue(eConfirmIndicator)}
          />
        )}
        {eProspectusIndicator && (
          <Definition
            term="Prospectus"
            definition={displayValue(eProspectusIndicator)}
          />
        )}
        {eProxyIndicator && (
          <Definition term="Proxy" definition={displayValue(eProxyIndicator)} />
        )}
        {eTaxStatementIndicator && (
          <Definition
            term="Tax Statements"
            definition={displayValue(eTaxStatementIndicator)}
          />
        )}
      </DefinitionList>
    </Section>
  )
}

export default EPreferencesTable
